import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import CustomButton from "../../helper-components/input/CustomButton";

import { getLanguage } from "../../config/language/language";

/**
 * A page notifying the user he's been signed out.
 */
export default function LogOut(props) {
    return (
        <Grid container component="main" sx={{ height: "75vh" }}>
            <Grid
                item
                xs={false}
                sm={5}
                md={8}
                sx={{
                    backgroundImage: `url("${process.env.PUBLIC_URL}/images/books.jpg")`,
                    backgroundRepeat: "no-repeat",
                    backgroundColor: (t) => (t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900]),
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}
            />

            <Grid item xs={12} sm={7} md={4} component={Paper} elevation={3}>
                <Grid item xs={12}>
                    <Paper
                        sx={{
                            p: 5,
                            m: 2,
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center"
                        }}>
                        <Typography variant="h4">{getLanguage().LOGGED_OUT}</Typography>

                        <br />

                        <Typography variant="p">{getLanguage().NEXT_TIME}</Typography>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper
                        sx={{
                            p: 2,
                            m: 2,
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center"
                        }}>
                        <Typography variant="p">{getLanguage().LOG_BACK_IN}</Typography>

                        <br />

                        <Typography style={{ whiteSpace: "pre-line" }}>
                            <CustomButton {...props} title={getLanguage().BUTTON_SIGNIN} path="/signin" />
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
}
